// ToastService.ts
import axios from 'axios';
import Swal from 'sweetalert2';

type AnyOpts = Record<string, any>;

// --- Fila GLOBAL (compartilhada por todo o app) ---
declare global {
  interface Window {
    __swalQueue__: Promise<any>;
  }
}
if (!window.__swalQueue__) {
  window.__swalQueue__ = Promise.resolve();
}
// helper que serializa execuções (independente de instância)
function enqueue<T>(task: () => Promise<T>): Promise<T> {
  const run = window.__swalQueue__.then(task, task); // garante execução mesmo se a fila anterior falhou
  // encadeia o término (absorvendo erros pra não "quebrar" a fila)
  window.__swalQueue__ = run.then(
    () => Promise.resolve(),
    () => Promise.resolve()
  );
  return run;
}

class ToastService {
  private Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast: HTMLElement) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  // garante que TODO fire passe pela fila global
  private fire(opts: AnyOpts) {
    return enqueue(() => this.Toast.fire(opts));
  }

  alertaSucesso(msg: string) {
    return this.fire({ title: msg, icon: 'success' });
  }

  alertaErro(msg: string) {
    return this.fire({ title: msg, icon: 'error', timer: 5000, timerProgressBar: true });
  }

  alertaWarning(msg: string) {
    return this.fire({ title: msg, icon: 'warning', timer: 5000, timerProgressBar: true });
  }

  alertaBootstrapRelatorio(nomeArquivo: string, url: string) {
    const urlRelatorio = url;
    const nomeArquivoRelatorio = nomeArquivo;
    let type = {};
    if (url.toLocaleLowerCase().indexOf('pdf') >= 0) type = { type: 'application/pdf' };
    else if (url.toLocaleLowerCase().indexOf('xls') >= 0) type = { type: 'application/vnd.ms-excel' };
    else if (url.toLocaleLowerCase().indexOf('xlsx') >= 0) type = { type: 'application/vnd.ms-excel' };

    this.fire({
      confirmButtonText: 'Baixar',
      showConfirmButton: true,
      timer: 10000,
      width: '40%',
      timerProgressBar: true,
      didOpen: (toast: any) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
      title: `<p>${nomeArquivoRelatorio.length > 12 ? nomeArquivoRelatorio.substring(0, 12) + '...' : nomeArquivoRelatorio} gerado com sucesso, clique no botão para visualizar ou acesse as notificações para visualiza-lo.`,
      icon: 'info',
      customClass: {
        popup: 'd-flex justify-content-between',
        actions: 'd-flex justify-content-end'
      },
      preConfirm: async () => {
        axios.get(urlRelatorio, { responseType: 'blob' }).then((response: any) => {
          const url = window.URL.createObjectURL(new Blob([response.data], type));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', nomeArquivoRelatorio);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        });
      }
    });
  }

  // Modais "reais" (não toasts) não passam pela fila (normalmente você quer que eles apareçam imediatamente)
  confirmDelete(itemLabel?: string) {
    return Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger btn-simple'
      },
      buttonsStyling: false
    }).fire({
      title: 'Tem certeza?',
      text: `Deseja deletar o item${itemLabel ? ` '${itemLabel}'` : ''}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    });
  }

  confirm(message: string) {
    return Swal.fire({
      text: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger btn-simple'
      },
      buttonsStyling: false
    });
  }
}

export default new ToastService();
